var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "modelscr-container": true, hasTagsView: _vm.needTagsView } },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            width: "100%",
            title: _vm.dialogTitle,
            visible: _vm.isVisible,
            modal: _vm.modal,
            "modal-append-to-body": _vm.modalAppendToBody,
            "append-to-body": _vm.appendToBody,
            "show-close": _vm.showClose,
            "lock-scroll": _vm.lockScroll,
            center: _vm.center,
            top: _vm.top,
            "custom-class": _vm.customClass,
            "close-on-click-modal": _vm.closeOnClickModal,
            "close-on-press-escape": _vm.closeOnPressEscape,
            "destroy-on-close": _vm.destroyOnClose,
            "before-close": _vm.clickCloseBtn,
          },
          on: {
            "update:visible": function ($event) {
              _vm.isVisible = $event
            },
            closed: _vm.closeFunc,
          },
        },
        [
          _c(
            "div",
            { ref: "detailSlot", staticClass: "detail-slot" },
            [_vm._t("content")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [_vm._t("footer-btn")],
            2
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }